export default __webpack_public_path__ + "static/media/arrow-right.c8436991.svg";